module.exports = __webpack_public_path__ + "img/BUTAGAZ_120X35.3013d70f.png";